export default "__VITE_ASSET__B0kPoIN0__"